import React from 'react';
import { Outlet } from 'react-router-dom';
import "./mainHome.scss";
import MenuSideBar from '../pages/Menu';

const MainHome: React.FC = () => {
  return (
    <div className="main-home-container full-width-height">
      <div className="content-container">
        <MenuSideBar />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainHome;
